import React from "react";
import { Button, Form, Input, Typography } from "antd";
import AppModalWrapper from "../components/Items/Modal/AppModalWrapper";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "../redux-toolkit/store/store";
import useMultiNotification from "../hooks/useNotification";
import { createNewFormulaApi } from "../redux-toolkit/slices/formulasSlice";
const { Title } = Typography;

const AddNewFormulaModal: React.FC<GeneralModalProps> = ({
  show,
  handleClose,
}) => {
  const { contextHolder, openNotification } = useMultiNotification();
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const {} = useSelector((state: RootState) => state.dashboard);
  const onFinish = async (values: ICreateNewFormulaApi) => {
    try {
      const res = await dispatch(createNewFormulaApi(values)).unwrap();
      openNotification(`success`, `Success`, res.message);
      setTimeout(() => {
        handleClose(true);
      }, 1500);
    } catch (error) {
      if (typeof error === "string") {
        openNotification(`error`, `Error`, error);
      } else {
        openNotification(`error`, `Error`, `Server Error`);
      }
    }
  };
  const onFinishFailed = (data: any) => {};
  return (
    <>
      {contextHolder}
      <AppModalWrapper
        title="Create New Formula"
        headerStyle={{
          backgroundColor: "#f5f5f5",
          color: "#101828",
          fontSize: "16px",
          fontWeight: "700",
          height: "50px",
        }}
        open={show}
        onCancel={() => {
          handleClose(false);
        }}
      >
        <Form
          name="createNewFormulaForm"
          initialValues={{ remember: true }}
          layout="vertical"
          form={form}
          style={{ padding: "30px" }}
          requiredMark={false}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            label={<span>Active ingredients</span>}
            name="activeIngredients"
            rules={[
              { required: true, message: "Please input Active ingredients!" },
            ]}
          >
            <Input placeholder="diclofenac 8%, camphor 5%, menthol 5%" />
          </Form.Item>

          <Form.Item
            label={<span>Cream base</span>}
            name="creamBase"
            rules={[{ required: true, message: "Please input cream base!" }]}
          >
            <Input placeholder="Medisca Transdermal Pain Base QSAD" />
          </Form.Item>

          <Form.Item style={{ display: "flex", justifyContent: "center" }}>
            <Button type="primary" htmlType="submit">
              Create Formula
            </Button>
          </Form.Item>
        </Form>
      </AppModalWrapper>
    </>
  );
};
export default AddNewFormulaModal;
